export default "__VITE_ASSET__CWy655W$__"